<template>
	<td v-bind="attributes"><component :is="componentOfPart(itemPart)" :part="partRef(itemPart)" :data="object" :readonly="!allowedToEdit"></component></td>
</template>

<script setup lang="ts">
import {ref, computed, inject} from "vue";
import {CellBinding, injectItemsGrid} from "@fd/containers/agenda/AgendaUtils.ts";
import {injectComponentOfPart, injectPartRef} from "@fd/PartInjectKeys.ts";
import {DataGrid, ItemsGrid} from "@t/fd/layout/Agenda.ts";
import type {FormPartOrReference} from "@t/fd/FormPartOrReference.ts";
import {hasAccess, secureRootKey} from "@t/security/ObjectAccess.ts";

const props = withDefaults(defineProps<{
	object: object,
	readonly?: boolean
}>(), { readonly: false });

const partRef = injectPartRef();
const componentOfPart = injectComponentOfPart();
const grid = injectItemsGrid();

const itemPart = computed<FormPartOrReference>(() => (grid.value as ItemsGrid).item);

let secRoot = inject(secureRootKey);
const allowedToEdit = computed(() => !props.readonly && hasAccess(secRoot, "edit"));

const attributes = computed<CellBinding|null>(() => {
	const bind:CellBinding = {};
	return bind;
});

</script>

<style>

</style>